<template>
  <div v-if="id">
    <v-card>
      <v-card-text class="pa-3">
        <div class="text-right" v-if="enrolment && enrolment.course_id != enrolment.original_course_id">
          <v-chip class="ma-0" color="primary darken-2" small label>{{
            $t("enrolments.original_course") + ": " + original_course_name
          }}</v-chip>
        </div>
        <p class="font-weight-black sidebar-price-title mb-0">{{ $t("fe.enrolment.include") }}</p>

        <v-simple-table dense>
          <template v-for="mt in moduletemplates_included">
            <tr :key="mt.mt_id + '-' + $uuid()" class="grey-tr">
              <td scope="row" colspan="2" class="font-weight-black text-gray pl-1">{{ mt.name }}</td>
            </tr>
            <tr :key="mt.mo_id + '-' + $uuid()" class="white-tr" v-if="mt.mo_id">
              <td scope="row">{{ mt.mo_name }} {{ mt.mo_hours ? " (" + mt.mo_hours + " " + $t("moduleoptions.hours") + ")" : "" }}</td>
              <td scope="row" class="text-end" width="20%">{{ mt.mo_price ? mt.mo_price + " " + CURRENCY : "" }}</td>
            </tr>
            <tr :key="mt.id + '-' + mt.mo_id + '-' + $uuid()" class="white-tr" v-if="mt.moct && mt.moct.length > 0">
              <td colspan="2" class="pr-0" style="background: white">
                <v-simple-table dense class="ml-5">
                  <tr v-for="moct in mt.moct" :key="moct.id + '-' + $uuid()">
                    <td scope="row">{{ moct.name }}</td>
                    <td scope="row" class="text-end" width="20%">
                      {{ moct.price ? moct.price + " " + CURRENCY : "" }}
                    </td>
                  </tr>
                </v-simple-table>
              </td>
            </tr>
          </template>
        </v-simple-table>

        <p class="font-weight-black mt-3 sidebar-price-title mb-0">{{ $t("fe.enrolment.additionals") }}</p>

        <v-simple-table dense>
          <template v-for="mt in moduletemplates_not_included">
            <tr :key="mt.mt_id + '-' + $uuid()" class="grey-tr">
              <td scope="row" colspan="2" class="font-weight-black text-gray pl-1">{{ mt.name }}</td>
            </tr>
            <tr :key="mt.mo_id + '-' + $uuid()" class="white-tr" v-if="mt.mo_id">
              <td scope="row">{{ mt.mo_name }} {{ mt.mo_hours ? " (" + mt.mo_hours + " " + $t("moduleoptions.hours") + ")" : "" }}</td>
              <td scope="row" class="text-end" width="20%">{{ mt.mo_price ? mt.mo_price + " " + CURRENCY : "" }}</td>
            </tr>
            <tr :key="mt.id + '-' + mt.mo_id + '-' + $uuid()" class="white-tr" v-if="mt.moct && mt.moct.length > 0">
              <td colspan="2" class="pr-0" style="background: white">
                <v-simple-table dense class="ml-5">
                  <tr v-for="moct in mt.moct" :key="moct.id + '-' + $uuid()">
                    <td scope="row">{{ moct.name }}</td>
                    <td scope="row" class="text-end" width="20%">
                      {{ moct.price ? moct.price + " " + CURRENCY : "" }}
                    </td>
                  </tr>
                </v-simple-table>
              </td>
            </tr>
          </template>
        </v-simple-table>

        <v-divider class="my-3"></v-divider>

        <v-simple-table dense class="mt-3 mb-4">
          <tr class="white-tr">
            <td scope="row">
              <p class="font-weight-black mb-0">{{ $t("fe.enrolment.price") }}</p>
            </td>
            <td scope="row" class="text-end" width="40%">{{ price + " " + CURRENCY }}</td>
          </tr>
          <tr class="white-tr">
            <td scope="row">
              <p class="font-weight-black mb-0">{{ $t("fe.enrolment.price_additional") }}</p>
            </td>
            <td scope="row" class="text-end" width="40%">{{ price_additional + " " + CURRENCY }}</td>
          </tr>
          <tr class="white-tr">
            <td scope="row">
              <p class="font-weight-black mb-0">{{ $t("fe.enrolment.price_total") }}</p>
            </td>
            <td scope="row" class="text-end" width="40%">{{ price_total + " " + CURRENCY }}</td>
          </tr>
        </v-simple-table>

        <v-layout row wrap>
          <v-flex xs12 sm8 class="text-left" v-if="enrolment.created_at">
            <p class="pa-0 mb-0">
              {{ $t("attendees.enrolled_date") + ":" + moment.utc(enrolment.created_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
              <span v-if="enrolment.updated_at && enrolment.updated_by_name">
                <br/>
                {{ $t("enrolments.enrolment_updated") + ":" + enrolment.updated_by_name +  " "  + moment.utc(enrolment.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
              </span>
            </p>
          </v-flex>
          <v-flex xs12 sm4 class="text-right" v-if="enrolment.payment && enrolment.payment.payment_method">
            {{ $t("enrolments.payment_method") + ":" }}
            <b>{{ enrolment.payment.payment_method.toUpperCase() || null }}</b>
          </v-flex>

          <v-flex xs12 class="text-left" v-if="enrolment.participant_id && enrolment.participant_mapped">
               {{ $t("enrolments.mapped_to") }}
               <router-link :to="{ path: BACKEND_URL + '/participants/edit/' + enrolment.participant_id}">
                {{ enrolment.participant_mapped }}
              </router-link>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "EnrolmentDetails",

  props: {
    id: {
      type: Number,
      required: true
    },
    token: {
      type: String
    }
  },

  data() {
    return {
      enrolment: {},

      original_course_name: "",
      additionals_data: [],
      moduletemplates_included: [],
      moduletemplates_not_included: [],

      price: 0,
      price_additional: 0,
      price_total: 0
    }
  },

  created() {
    this.getEnrolment(this.id)
  },

  methods: {
    getEnrolment(id) {
      if (id) {
        let url = this.API_URL + "enrolment/" + id

        if (this.token) {
          url = this.API_URL + "open/enrolment/" + id + "/" + this.token
        }

        axios.get(url).then((res) => {
          this.enrolment = res.data.data

          let additionals = this.enrolment.additionals
          let price_additional = 0
          let course_data = JSON.parse(this.enrolment.original_course_data)

          if (course_data && additionals) {
            this.original_course_name = course_data.course.name

            // Get module templates and module options
            additionals.forEach((item, index) => {
              let mt = course_data.course.moduletemplates.find((i) => i.id == item.moduletemplate_id)
              if (mt && typeof mt.moduleoptions !== "undefined") {
                let mo = mt.moduleoptions.find((i) => i.id == item.moduleoption_id)

                if (mt && mo && !this.additionals_data.find((i) => i.mt_id == item.moduletemplate_id)) {
                  this.additionals_data.push({
                    mt_id: mt.id,
                    mo_id: mo ? mo.id : null,
                    name: mt.name,
                    price: mt.price,
                    hours: mt.req_hours,
                    is_included: mt.is_included,
                    mo_name: mo ? mo.name : null,
                    mo_price: mo ? mo.price : null,
                    mo_hours: mo ? mo.hours : null,
                    moct: []
                  })

                  if (mo && mo.price) {
                    price_additional += mo.price
                  }
                }
              }
            })

            // Get module option coursetypes
            additionals.forEach((item, index) => {
              let mt = course_data.course.moduletemplates.find((i) => i.id == item.moduletemplate_id)
              if (mt && typeof mt.moduleoptions !== "undefined") {
                let mo = mt.moduleoptions.find((i) => i.id == item.moduleoption_id)

                if (mt && mo) {
                  let moct = mo.coursetypes.find((i) => i.id == item.moduleoptioncoursetype_id)

                  if (moct) {
                    this.additionals_data
                      .find((i) => i.mt_id == item.moduletemplate_id && i.mo_id == item.moduleoption_id)
                      ["moct"].push({
                        name: moct.name,
                        price: moct.price
                      })

                    if (moct.price) {
                      price_additional += moct.price
                    }
                  }
                }
              }
            })

            // Filter is_included
            this.moduletemplates_included = this.additionals_data.filter((i) => i.is_included)
            this.moduletemplates_not_included = this.additionals_data.filter((i) => !i.is_included)

            // compute price
            this.price = course_data.course.price || 0
            this.price_additional = price_additional
            this.price_total = this.price + this.price_additional
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.text-gray {
  color: rgba(0, 0, 0, 0.54) !important;
}
.white-tr {
  background: none !important;
}
.grey-tr {
  background: rgba(0, 0, 0, 0.12) !important;
}
.white-tr td {
  border-bottom: none !important;
}
</style>
